import React, { useEffect, useMemo, useRef, useState } from "react";
import "./mspSubscriptionAccounts.scss";
import { GreyLoader } from "../../Theme/APILoaders";
import { HGHighlightText } from "../../App/App";
import { getAPIData, postData } from "../../../Utils/commonApi";
import { CallToast } from "../../PriceCalculator/modals/CustomToast";
import { useAuth } from "../../context/Auth";
import { useNavigate, useLocation } from "react-router-dom";
import { throttle } from "lodash";
import MembersPageLoader from "../../settingsV2/members/MembersPageLoader";
import { TrimString } from "../../../Utils/StringTrimmer";
import { ROUTE_PATHS } from "../../../constants/app.constants";
import useFilters from "../../../hooks/filters.hook";
import SortingHeaderComponent from "../../Common/SearchFilterComponent/SortingHeaderComponent";
import useDateFormat from "../../../hooks/use-date-format.hook";
import { useEntity } from "../../../hooks/use-entity.hook";
import { Flaggers } from "../../../common/store/flaggers/flaggers.enum";
import { FlaggersMethods } from "../../../common/store/flaggers/flaggers.methods";
import InviteMspModal from "./invite-msp-modal/invite-msp.modal";
import MspAccountsHeader from "./msp-accounts-page-header/MspAccountsHeader";
import MspAccountsBanner from "./msp-accounts-page-header/MspAccountsBanner";
import { MspAccountsTable } from "./msp-accounts-table";
import PaginationButtonsBlock from "../../pagination-block/pagination-buttons-block";

const MspSubscriptionAccounts = () => {
  const location = useLocation();
  const [selectedRows, setSelectedRows] = useState([]);
  const [forceShowCheckboxes, setForceShowCheckboxes] = useState(false);

  const handleSelectionChange = (selected) => {
    setSelectedRows(selected);
    // Once checkboxes are shown (via selection or force), keep them visible
    // Set forceShowCheckboxes to true when 2+ items are selected so checkboxes stay visible
    if (selected.length >= 2 && !forceShowCheckboxes) {
      setForceShowCheckboxes(true);
    }
    // Keep checkboxes visible even when all are unchecked (forceShowCheckboxes stays true)
  };

  const handleBulkAction = (action) => {
    console.log(`Bulk action: ${action}`, selectedRows);
    // Only hide checkboxes when explicitly closing (cross button clicked)
    if (action === "close") {
      setForceShowCheckboxes(false);
      setSelectedRows([]);
    } else {
      // For other actions, clear selection but keep checkboxes visible
      setSelectedRows([]);
    }
  };

  const handleSelectRows = () => {
    setForceShowCheckboxes(true);
  };
  const queryParams = new URLSearchParams(location.search);
  const variant = queryParams.get("variant") ?? 'v1';
  const mode = queryParams.get("mode");
  const isDistributor = mode === "distributor";
  console.log('variant', variant);
  const { entityData: mspInviteData, setEntityData: setMspInviteData } = useEntity({ entityType: Flaggers.MspInviteFlagger });
  const dateFormat = useDateFormat();
    const SearchInput = useRef();
    const navigate = useNavigate()
    const {authTokens} = useAuth()
    const [searchString, setSearchString] = useState("");
    const [searchInput, setSearchInput] = useState(false);
    const [timeoutId, setTimeoutId] = useState();
    const [headersList, setHeadersList] = useState([])
  const [ClientNumber, setClientNumber] = useState(0);
const [loading, setLoading] = useState(false)
const [isArchived, setIsArchived] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const { selectedFilters, setSelectedFilters, addFilter } = useFilters({
    onFiltersUpdate: (filters) => {
      // Don't call API for v2 variant
      if (variant === 'v2') {
        return;
      }

      let updated_filter = [{"AccountFilter_Enum":1,"FilterText_List":[searchString]}];

      filters.forEach(filter => {
        const filterEnum = filter.key;
        if (Array.isArray(filter.value)) {
          updated_filter.push({
            AccountFilter_Enum: filterEnum,
            FilterText_List: filter.value
              .filter(item => item.value)
              .map(item => item.key)
          });
          return;
        }
        if (filter.type === "date-range") {
          updated_filter.push({
            AccountFilter_Enum: filterEnum,
            FilterText_List: [filter.value?.startDate?.toISOString(), filter.value?.endDate?.toISOString()]
          });
          return;
        }
        updated_filter.push({
          AccountFilter_Enum: filterEnum,
          FilterText_List: [filter.value]
        });
      });
      setmspFilters(JSON.stringify(updated_filter));
      getPageData({
        ClientNumber: 0,
        AccountFilter_List: JSON.stringify(updated_filter),
      }).then(() => {
        setListDataLoading(false);
      }).catch((err) => {
        console.error("Error fetching page data:", err);
        setListDataLoading(false);
      });
    }
  });
    const [fetchingNewClients, setFetchingNewClients] = useState(false);
    const [listDataLoading, setListDataLoading] = useState(false);

    const [mspFilters, setmspFilters] = useState(
      `[{"AccountFilter_Enum":1,"FilterText_List":[""]}]`
    );
    const [pageData, setPageData] = useState({})
    const [bannerData, setBannerData] = useState({})
    const tableFilters = useMemo(() => {
      if (variant === 'v2') {
        const filters = [];
        
        // Add "Distributor" filter if isDistributor is false
        if (isDistributor === false) {
          filters.push({
            filterType: "radio-range",
            filterKey: "distributor",
            filterTitle: "Distributor",
            text: 'Distributor',
          });
        }
        
        // Add the rest of the filters
        filters.push(
          {
            filterType: "radio-range",
            filterKey: "salesRep",
            filterTitle: "Sales Rep",
            text: 'Sales Rep'
          },
          {
            filterType: "radio-range",
            filterKey: 6,
            filterTitle: "Subscription",
            filterValue: bannerData?.plans?.map((item) => ({
              value: false,
              label: item?.Label,
              key: item?.Label,
            })),
            text: 'Subscription'
          },
          {
            filterType: "radio-range",
            filterKey: "overSubscription",
            filterTitle: "Over-Subscription",
            text: 'Over-Subscription'
          },
          {
            filterType: "radio-range",
            filterKey: "renewal",
            filterTitle: "Renewal",
            text: 'Renewal'
          },
          {
            filterType: "radio-range",
            filterKey: "tags",
            filterTitle: "Tags",
            text: 'Tags'
          },
          {
            filterType: "radio-range",
            filterKey: "autoRenewal",
            filterTitle: "Auto Renewal",
            text: 'Auto Renewal'
          },
          {
            filterType: "radio-range",
            filterKey: "status",
            filterTitle: "Status",
            text: 'Status'
          }
        );
        
        return filters;
      }
      
      return [
        {
          filterType: "radio-range",
          filterKey: 6,
          filterTitle: "Subscription",
          filterValue: bannerData?.plans?.map((item) => ({
            value: false,
            label: item?.Label,
            key: item?.Label,
          })),
          text: 'Subscription'
        },
        {
          filterType: "radio-range",
          filterKey: 2,
          filterTitle: "Location",
          filterValue: [
            { value: false, label: "United Kingdom", key: "United Kingdom" }
          ],
          text: 'Location'
        },
        {
          filterType: "date-range",
          filterKey: 4,
          filterTitle: "Signed Up",
          text: 'Signed Up'
        },
        {
          filterType: "date-range",
          filterKey: 5,
          filterTitle: "Last Login",
          text: 'Last Login'
        },
        {
          filterType: "date-range",
          filterKey: 7,
          filterTitle: "Trial Expiry",
          text: 'Trial Expiry'
        }
      ];
    }, [variant, bannerData?.plans, isDistributor])
    const [sortData, setSortData] = useState({
      sortItem: "Company_Name",
      sortOrder: 1,
      sorting: false,
    });
      function sortRecords(_fieldKey) {
        let _sortOrder = 0;
        if (sortData.sortItem === _fieldKey) {
          _sortOrder = sortData.sortOrder === 1 ? 0 : 1;
        } else {
          _sortOrder = 1;
        }
    
        setSortData({
          sortItem: _fieldKey,
          sortOrder: _sortOrder,
          sorting: true,
        });
    
        getPageData({
          ClientNumber: 0,
          sortItem: _fieldKey,
          sortOrder: _sortOrder,
        }).then(() => {
          setSortData({
            sortItem: _fieldKey,
            sortOrder: _sortOrder,
            sorting: false,
          });
        }).catch((err) => {
          console.error("Error sorting records:", err);
          setSortData({
            sortItem: _fieldKey,
            sortOrder: _sortOrder,
            sorting: false,
          });
        });
      }
      const handleInputChange = (event) => {
        const { value } = event.target;
        setSearchString(value);
        // sessionStorage.setItem("mspClientSearchString", value);
        let updated_filter = JSON.parse(mspFilters);
        updated_filter[0].FilterText_List[0] = value;
        setmspFilters(JSON.stringify(updated_filter));
    
        // Clear the previous timeout
        clearTimeout(timeoutId);
    
        // Set a new timeout to call the API after 1 second
        let _timeoutId = setTimeout(() => {
          // setListDataLoading(true);
          getPageData({
            ClientNumber: 0,
            AccountFilter_List: JSON.stringify(updated_filter),
          }).then(() => {
            // setListDataLoading(false);
          }).catch((err) => {
            console.error("Error fetching page data on input change:", err);
            // setListDataLoading(false);
          });
        }, 800);
        setTimeoutId(_timeoutId);
      };






  useEffect(() => {
    // Don't fetch data for v2 variant - it uses hardcoded data
    if (variant === 'v2') {
      setLoading(false);
      return;
    }
    
    setLoading(true)
    getBannerData()
    getColumnheaderList()
  }, [variant])
  
  
  function getBannerData(){
    return new Promise((resolve, reject) => {
      getAPIData("3", authTokens, {
        optionEnum1:1
      })
        .then((response) => {
        if(response?.mr?.Success){
          setBannerData(response)
        }
          
          resolve(response); // Resolve the promise
        })
        .catch((err) => {
          console.log(err);
          CallToast("Something went wrong", false, false, "v2style");
           
          reject(err); // Reject the promise
        });
    });
  }
  
  


  function getColumnheaderList(kwargs) {
    setListDataLoading(true)
    getAPIData(4, authTokens,{
      optionEnum1:1,
      optionEnum2:kwargs?.archived ?? Number(isArchived)
    }).then((response) => {
      if (response?.mr?.Success) {
        setHeadersList(response?.AccountSortVisibility_List);
 
    
          getPageData({
            AccountSortVisibility_List: JSON.stringify(
              response?.AccountSortVisibility_List,
             
            ), isArchived : Boolean(kwargs?.archived),
            ClientNumber:0
          }).catch((err) => {
            console.error("Error fetching page data after column header update:", err);
            setListDataLoading(false);
          });
         
      } else {
      }
    });
  }


   function getPageData(kwargs) {
    setListDataLoading(true)
    if(typeof kwargs?.isArchived ==="boolean"){
    setIsArchived(kwargs?.isArchived)
    }

     
    return new Promise((resolve, reject) => {
      postData(authTokens, "Accounts", {
        AccountType:1,
 
        ObjectId: 0,
        pageSize:20,
        ClientNumber: kwargs?.ClientNumber ?? ClientNumber,
        isArchived:kwargs?.isArchived ?? isArchived,
        AccountSortOrder: kwargs?.sortOrder ?? sortData.sortOrder,
        AccountSort: kwargs?.sortItem ?? sortData.sortItem,
        AccountFilter_List: kwargs?.AccountFilter_List ?? mspFilters,
        AccountSortVisibility_List:
          kwargs?.AccountSortVisibility_List ?? JSON.stringify(headersList),
        // accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
      })
        .then((response) => {
          setLoading(false);
    setListDataLoading(false)

          if (response?.mr?.Success) {
          
     
            setClientNumber(response?.ClientNumber);
            if (kwargs?.ClientNumber === 0 || ClientNumber === 0) {
              setPageData(response);
            } else {
              let new_output = response;

              let old_client_data = [...pageData.AccountRowData_List];
              old_client_data.push(...new_output.AccountRowData_List);

              let updated_data = {
                ...new_output,
                AccountRowData_List: old_client_data,
              };

              setPageData(updated_data);
            }
            resolve(response);
          } else {
            reject("false");
          }
        })
        .catch((err) => {
          console.log(err);
          reject("false");
        });
    });
  }



  const throttledFetchData = throttle(getMoreClients, 100);
  async function getMoreClients(e) {
    try {
      if (
        e.target.clientHeight + e.target.scrollTop + 20 >=
        e.target.scrollHeight
      ) {
        if (ClientNumber === 0 || ClientNumber >= pageData?.TotalClients) return;

        let element = document.getElementById("body-container-id");
        element.removeEventListener("scroll", throttledFetchData);

        setFetchingNewClients(true);

        getPageData({
          ClientNumber: ClientNumber + 1
        }).then(() => {
          setFetchingNewClients(false);
        }).catch((err) => {
          console.error("Error fetching more clients:", err);
          setFetchingNewClients(false);
        });

      }
    } catch (error) {
      console.log("error occurred", error);
    }
  }

  useEffect(() => {
    // Don't add scroll listener for v2 variant
    if (variant === 'v2') {
      return;
    }
    
    var element = document.getElementById("body-container-id");
    element.removeEventListener("scroll", throttledFetchData);
    element.addEventListener("scroll", throttledFetchData);

    return () => {
      var cleanupElement = document.getElementById("body-container-id");
      if (cleanupElement) {
        cleanupElement.removeEventListener("scroll", throttledFetchData);
      }
    };
  }, [pageData, fetchingNewClients, variant]);

  const tableStyle = useMemo(() => 
    `repeat(${pageData?.AccountSortVisibility_List?.filter(item => item?.Visibility === true)?.length}, 1fr)`,
    [pageData?.AccountSortVisibility_List]
  );
  
  return (
    <div className="msp-subscription-accounts px-4">
        
{ loading?  <MembersPageLoader />  :     <>
      {variant !== 'v2' && <MspAccountsBanner bannerData={bannerData} />}

<MspAccountsHeader
                variant={variant}
                totalClients={pageData?.TotalClients}
                listDataLoading={listDataLoading}
                searchString={searchString}
                searchInputRef={SearchInput}
                handleInputChange={handleInputChange}
                setSearchInput={setSearchInput}
                tableFilters={tableFilters}
                addFilter={addFilter}
                headersList={headersList}
                setHeadersList={setHeadersList}
                getPageData={getPageData}
                sortData={sortData}
                sortRecords={sortRecords}
                onInviteClick={() => {
                  setMspInviteData({
                    showModal: true,
                    companyName: '',
                    userName: '',
                    companyEmail: '',
                    country: '',
                  }, FlaggersMethods.UpdateFlagger);
                }}
                selectedFilters={selectedFilters}
                setSelectedFilters={setSelectedFilters}
                dateFormat={dateFormat}
                isArchived={isArchived}
                selectedRows={selectedRows}
                onBulkAction={handleBulkAction}
                onSelectRows={handleSelectRows}
                forceShowCheckboxes={forceShowCheckboxes}
              />

  {variant === 'v2' ? (
    <>
      <div className="mt-3">
        <MspAccountsTable 
          isArchived={isArchived} 
          onSelectionChange={handleSelectionChange} 
          forceShowCheckboxes={forceShowCheckboxes} 
          variant={variant}
          isDistributor={isDistributor}
        />
      </div>
      <div className="mt-4 d-flex justify-content-start">
        <PaginationButtonsBlock
          pageNumber={currentPage}
          maxPageNumber={10}
          onButtonClick={(page) => setCurrentPage(page)}
          onArrowClick={(isNext) => {
            // Left arrow passes false, right arrow passes nothing (undefined)
            if (isNext === false) {
              setCurrentPage(prev => Math.max(prev - 1, 1));
            } else {
              setCurrentPage(prev => Math.min(prev + 1, 10));
            }
          }}
        />
      </div>
    </>
  ) : (
    <>
      {pageData?.AccountRowData_List?.length===0?
      
      
      <div className="d-flex flex-column justify-content-center mx-auto w-fit-content mt-5">
                    <img
                      src="/images/msp/file-icon.svg"
                      alt=""
                      className="mx-auto"
                      width={40}
                      height={40}
                    />

                    <div className="f-600 f-grey mt-4 w-100 text-center">
                    No MSP Accounts yet
                    </div>
                    <div className=" f-darkgrey mt-2  w-fit-content">
                    There are no MSP Accounts yet
                    </div>
                  </div>
      
      :<div className="mt-3 hide-scrollbar"     style={
                          {
                            overflowX:"auto"
                          }
                        }>
                  <div
                    className="msp-clients-table bg-grey radius-8 border-parent position-relative"
                    style={
                      {
                         width: "max-content",
                         minWidth: "100%",
                      }
                    }
                  >
                    {listDataLoading && (
                      <div
                        className="position-absolute w-100 h-100 bg-white"
                        style={{
                          opacity: "0.6",
                          zIndex: "2",
                        }}
                      ></div>
                    )}
                    {/* Header */}
                    <div className="border-item p-2 " style={{gridTemplateColumns: tableStyle}}>
                      {pageData?.AccountSortVisibility_List?.sort(
                        (a, b) => a.SortOrder - b.SortOrder
                      ).map((headerItem, headerItemIndex) => {
                          return (
                            <>
                              {headerItem?.Visibility === true && (
                                <>
                                  {headerItem?.FieldKey === "Client_Name" && (
                                    <div
                                      className={`f-12 f-grey d-flex align-items-center pointer  justify-content-start --`}
                                      style={{ width: "16rem" }}
                                      onClick={() => {
                                        sortRecords(headerItem?.FieldKey);
                                      }}
                                    >
                                      Client Name
                                      {sortData.sortItem === "Client_Name" && (
                                        <>
                                          {sortData?.sorting ? (
                                            <GreyLoader width={10} />
                                          ) : (
                                            <img
                                              alt=""
                                              src="/images/actioncenter/arrowdown.svg"
                                              className={`ml-2 ${
                                                sortData.sortOrder === 0
                                                  ? "rotate180"
                                                  : ""
                                              }`}
                                            />
                                          )}
                                        </>
                                      )}
                                    </div>
                                  )}

                                  <SortingHeaderComponent
                                    headerName={headerItem?.FieldName}
                                    headerKey={headerItem?.FieldKey}
                                    sortData={sortData}
                                    onSortClick={() => {
                                      sortRecords(headerItem?.FieldKey)
                                    }}
                                    updatedHeaderList={() => {
                                      const updatedData = headersList.map(item => {
                                        if (item?.FieldKey === headerItem?.FieldKey) {
                                          return { ...item, Visibility: false };
                                        }
                                        return item;
                                      });
                                      getPageData({
                                        AccountSortVisibility_List: JSON.stringify(updatedData),
                                        ClientNumber: 0,
                                      }).catch((err) => {
                                        console.error("Error fetching page data after header visibility update:", err);
                                      });
                                      setHeadersList(updatedData);
                                    }}
                                  />
                                </>
                              )}
                            </>
                          );
                        })}

                     
                    </div>

                    {/* TABLE BODY */}
                    {pageData?.AccountRowData_List?.map(
                      (tableBody, index) => {
                        return (
                          <div
                            className="border-item p-2  parent-visible bg-hover-dark-grey pointer"
                            onClick={() => {
                              navigate(ROUTE_PATHS.subscriptionPortalPages.mspAccountDetails(tableBody?.objId_Customer))
                            }}
                            style={{gridTemplateColumns: tableStyle}}
                          >
                           


                           {pageData?.AccountSortVisibility_List?.sort(
                        (a, b) => a.SortOrder - b.SortOrder
                      ).map((sortItem, sortItemIndex) => {
                          return (
                            <>
                              {sortItem?.Visibility === true && (
                                <>
                                 {
                      tableBody?.AccountColumnData_List?.map((tableBodyItem, tableBodyItemIndex) => {
                              return (
                                <>
                           {tableBodyItem?.FieldName=== sortItem?.FieldName &&     <>
                                  {tableBodyItem?.FieldName ===
                                    "Company Name" && (
                                    <div
                                      className=" d-flex align-items-center  justify-content-start pl-2  py-2"
                                      style={{ width: "16rem" }}
                                    >
                                      <img
                                        alt=""
                                        src={
                                          tableBodyItem?.Icon ??
                                          "/images/user-logo.svg"
                                        }
                                        className="ml-1 mr-2 rounded-full"
                                        width={32}
                                        height={32}
                                        onError={({ currentTarget }) => {
                                          currentTarget.onerror = null; // prevents looping
                                          currentTarget.src =
                                            "/images/user-logo.svg";
                                        }}
                                      />
                                      <div className="pr-3">
                                        <p className="f-500 f-black m-0">
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: HGHighlightText(
                                                tableBodyItem?.FieldValue1,
                                                searchString
                                              ),
                                            }}
                                          />
                                        </p>
                                        <p className="f-12 f-darkgrey">
                                         {tableBodyItem?.FieldValue3}
                                        </p>
                                      </div>
                                    </div>
                                  )}

                                  {tableBodyItem?.FieldName ===
                                    "Location" && (
                                    <div
                                      className={`f-12 f-black f-500 d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                     <span
                                        dangerouslySetInnerHTML={{
                                          __html: HGHighlightText(
                                            tableBodyItem?.FieldValue1,
                                            searchString
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Account Owner" && (
                                      <div
                                      className=" d-flex align-items-center  justify-content-start"
                                      style={{ width: "16rem" }}
                                    >
                                      <img
                                        alt=""
                                        src={
                                          tableBodyItem?.Icon ??
                                          "/images/user-logo.svg"
                                        }
                                        className="mr-2 rounded-full"
                                        width={32}
                                        height={32}
                                        onError={({ currentTarget }) => {
                                          currentTarget.onerror = null; // prevents looping
                                          currentTarget.src =
                                            "/images/user-logo.svg";
                                        }}
                                      />
                                      <div className="pr-3 text-ellipsis">
                                        <p className="f-500 f-black m-0 text-ellipsis">
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: HGHighlightText(
                                                tableBodyItem?.FieldValue1,
                                                searchString
                                              ),
                                            }}
                                          />
                                        </p>
                                        <p className="f-12 f-darkgrey">
                                        {TrimString(tableBodyItem?.FieldValue3,15)}
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Signed up" && (
                                    <div
                                      className={`f-12  d-flex  justify-content-start `}
                                      style={{ width: "16rem" ,
                                      color:tableBodyItem?.FieldValue1Color
                                      }}
                                    >
                                     <span
                                        dangerouslySetInnerHTML={{
                                          __html: HGHighlightText(
                                            tableBodyItem?.FieldValue1,
                                            searchString
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Last Log in" && (
                                    <div
                                      className={`f-12 f-black d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                     <span
                                        dangerouslySetInnerHTML={{
                                          __html: HGHighlightText(
                                            "12/01/24 17:00",
                                            searchString
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Subscription" && (
                                    <div
                                      className={`f-12  d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                     <div>
                                      <div>
                                        <span
                                          style={{
                                            color:tableBodyItem?.FieldValue1Color
                                          }}
                                          dangerouslySetInnerHTML={{
                                            __html: HGHighlightText(
                                              tableBodyItem?.FieldValue1,
                                              searchString
                                            ),
                                          }}
                                        />
                                        <span className="ml-2" 
                                          style={{
                                            color:tableBodyItem?.FieldValue2Color
                                          }}
                                          dangerouslySetInnerHTML={{
                                            __html: HGHighlightText(
                                              tableBodyItem?.FieldValue2,
                                              searchString
                                            ),
                                          }}
                                        />
                                      </div>
                                      <div>
                                        <span
                                          style={{
                                            color:tableBodyItem?.FieldValue3Color
                                          }}
                                          dangerouslySetInnerHTML={{
                                            __html: HGHighlightText(
                                              tableBodyItem?.FieldValue3,
                                              searchString
                                            ),
                                          }}
                                        />
                                      </div>
                                     </div>
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Trial Expiry" && (
                                    <div
                                      className={`f-12 d-flex  justify-content-start `}
                                      style={{ width: "16rem", color:tableBodyItem?.FieldValue1Color }}
                                    >
                                   <span
                                      dangerouslySetInnerHTML={{
                                        __html: HGHighlightText(
                                          tableBodyItem?.FieldValue1,
                                          searchString
                                        ),
                                      }}
                                    />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Qty Members" && (
                                    <div
                                      className={`f-12 f-black d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: HGHighlightText(
                                            tableBodyItem?.FieldValue1,
                                            searchString
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Qty Prospect Licenses" && (
                                    <div
                                      className={`f-12 f-black d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: HGHighlightText(
                                            tableBodyItem?.FieldValue1,
                                            searchString
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Qty Premium Licenses" && (
                                    <div
                                      className={`f-12 f-black d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: HGHighlightText(
                                            tableBodyItem?.FieldValue1,
                                            searchString
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Promo" && (
                                    <div
                                      className={`f-12 f-black d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: HGHighlightText(
                                          tableBodyItem?.FieldValue1,
                                          searchString
                                        ),
                                      }}
                                    />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Qty Integrations" && (
                                    <div
                                      className={`f-12 f-black d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                      <span
                                        dangerouslySetInnerHTML={{
                                          __html: HGHighlightText(
                                            tableBodyItem?.FieldValue1,
                                            searchString
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Qty Products" && (
                                    <div
                                      className={`f-12 f-black d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                     <span
                                        dangerouslySetInnerHTML={{
                                          __html: HGHighlightText(
                                            tableBodyItem?.FieldValue1,
                                            searchString
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Qty Services" && (
                                    <div
                                      className={`f-12 f-black d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                     <span
                                        dangerouslySetInnerHTML={{
                                          __html: HGHighlightText(
                                            tableBodyItem?.FieldValue1,
                                            searchString
                                          ),
                                        }}
                                      />
                                    </div>
                                  )}
                                  {tableBodyItem?.FieldName ===
                                    "Qty Packages" && (
                                    <div
                                      className={`f-12 f-black d-flex  justify-content-start `}
                                      style={{ width: "16rem" }}
                                    >
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: HGHighlightText(
                                          tableBodyItem?.FieldValue1,
                                          searchString
                                        ),
                                      }}
                                    />
                                    </div>
                                  )}
                                {tableBodyItem?.FieldName === "Last Login In" && (
                                  <div
                                    className="f-12  d-flex  justify-content-start"
                                    style={{ width: "16rem" }}
                                  >
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: HGHighlightText(
                                          tableBodyItem?.FieldValue1,
                                          searchString
                                        ),
                                      }}
                                    />
                                  </div>
                                )}
                                </>}
                                </>
                              );
                            })}
                                </>
                              )}
                            </>
                          );
                        })}
                          {/* <div className="d-flex justify-content-end mr-2 child-visible">
                            <button 
                              className="my-button bg-transparent f-12 line-height-18 f-grey f-500"
                              onClick={(e) => {
                                e.stopPropagation();
                              }
                            }>
                              Quick View
                            </button>
                          </div> */}
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>}
                </>
              )}
                <InviteMspModal 
                    isOpen={mspInviteData?.showModal} 
                    onClose={() => {
                      setMspInviteData(null, FlaggersMethods.UpdateFlagger);
                    }} 
                    onInviteSuccess={() => {
                      getPageData({
                        ClientNumber: 0,
                      }).catch((err) => {
                        console.error("Error fetching page data after invite success:", err);
                      });
                    }}
                    variant={variant}
                  />
                  {fetchingNewClients && (
                    <div className="d-flex align-items-center f-darkgrey ml-3">
                      <GreyLoader width={12} />
                      Loading...
                    </div>
                  )}
</>}
    </div>
  );
};

export default MspSubscriptionAccounts;
